(() => {
  const initialiseMarquee = (section) => {
    const viewport = section.querySelector('[data-dg-fact-viewport]');
    const track = section.querySelector('[data-dg-fact-track]');
    const seed = section.querySelector('[data-dg-fact-seed]');
    const clone = section.querySelector('[data-dg-fact-clone]');
    if (!viewport || !track || !seed || !clone || seed.dataset.initialised === 'true') return;
    if (viewport.classList.contains('dg-system__ticker--static')) return;

    const originalItems = seed.innerHTML;

    const rebuild = () => {
      seed.innerHTML = originalItems;
      clone.innerHTML = '';
      const targetWidth = viewport.clientWidth + 160;
      let repetitions = 0;
      while (seed.scrollWidth < targetWidth && repetitions < 16) {
        seed.insertAdjacentHTML('beforeend', originalItems);
        repetitions += 1;
      }
      clone.innerHTML = seed.innerHTML;
      const sequenceWidth = Math.ceil(seed.getBoundingClientRect().width);
      track.style.setProperty('--dg-fact-shift', `${sequenceWidth}px`);
      track.classList.add('dg-system__ticker-track--ready');
    };

    rebuild();
    let resizeTimer;
    const onResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(rebuild, 120);
    };
    window.addEventListener('resize', onResize, { passive: true });
    seed.dataset.initialised = 'true';
  };

  const initialiseAll = () => document.querySelectorAll('[data-dg-fact-marquee]').forEach(initialiseMarquee);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  else initialiseAll();
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-dg-fact-marquee]') || event.target;
    if (section.matches && section.matches('[data-dg-fact-marquee]')) initialiseMarquee(section);
  });
})();
